/*
 * The homepage's pill rows (sections/towsons-home-pills): tapping a pill changes the row
 * of mugs in place — the collection's first mugs, asked for at its own address
 * (?section_id=towsons-home-row) and kept, so going back to a pill is instant — and
 * "See all" follows it. Arrow keys move along the pills.
 */
(function () {
  'use strict';
  // What the shop sells, in its own word (its config, from the portal: lib/storefront/shopWords) — "mug" unless it says otherwise.
  function shopWord(one) { var w = (typeof window !== 'undefined' && window.Towsons && window.Towsons.words) || {}; return one ? (w.item || 'mug') : (w.items || 'mugs'); }
  if (window.TowsonsHome) return;
  var rows = {};

  function pick(pill) {
    var box = pill.closest('[data-thm-pills]');
    if (!box || pill.classList.contains('is-on')) return;
    var row = box.querySelector('[data-thm-row]');
    var all = box.querySelector('[data-thm-all]');
    Array.prototype.forEach.call(box.querySelectorAll('[data-thm-pill]'), function (p) {
      var on = p === pill;
      p.classList.toggle('is-on', on);
      p.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    var url = pill.getAttribute('data-url');
    if (all) {
      all.setAttribute('href', url);
      all.textContent = 'See all ' + pill.getAttribute('data-label') + ' ' + shopWord(false);
    }
    if (!row) return;
    var show = function (html) {
      if (pill.classList.contains('is-on')) { row.innerHTML = html; row.classList.remove('is-loading'); }
    };
    if (rows[url]) { show(rows[url]); return; }
    row.classList.add('is-loading');
    fetch(url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=towsons-home-row', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.shopify-section');
        rows[url] = inner ? inner.innerHTML : html;
        show(rows[url]);
      })
      .catch(function () { window.location.assign(url); });
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('[data-thm-pill]');
    if (pill) { e.preventDefault(); pick(pill); }
  });
  document.addEventListener('keydown', function (e) {
    var pill = e.target.closest && e.target.closest('[data-thm-pill]');
    if (!pill || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var all = Array.prototype.slice.call(pill.parentNode.querySelectorAll('[data-thm-pill]'));
    var next = all[(all.indexOf(pill) + (e.key === 'ArrowRight' ? 1 : -1) + all.length) % all.length];
    if (next) { e.preventDefault(); next.focus(); pick(next); }
  });

  window.TowsonsHome = { pick: pick };
})();
